const VARIANTS = {
  cyan: { c: "rgba(0,240,255,0.6)", f: "rgba(0,240,255,0.05)", g: "rgba(0,240,255,0.28)" },
  pink: { c: "rgba(255,0,127,0.6)", f: "rgba(255,0,127,0.05)", g: "rgba(255,0,127,0.28)" },
  green: { c: "rgba(57,255,20,0.55)", f: "rgba(57,255,20,0.05)", g: "rgba(57,255,20,0.25)" },
};

export const Cube3D = ({ className = "", size = 120, variant = "cyan", style = {} }) => {
  const v = VARIANTS[variant] || VARIANTS.cyan;
  return (
    <div
      aria-hidden
      className={`scene3d ${className}`}
      style={{ "--cube": `${size}px`, "--cube-color": v.c, "--cube-fill": v.f, "--cube-glow": v.g, ...style }}
    >
      <div className="cube3d">
        <span className="face fr" />
        <span className="face bk" />
        <span className="face rt" />
        <span className="face lf" />
        <span className="face tp" />
        <span className="face bt" />
      </div>
    </div>
  );
};
